import { useState, } from "react"
import { HeaderBody, Accordion, AccordionDetails, AccordionSummary, Box, } from "@fedsim/components"

export const LegalNotice = () => (
  <Box mb={2} height="100%" display="flex" flexDirection="column" justifyContent="space-around" alignItems="end">
    <p>Notice of Non-Affiliation and Disclaimer - contact us via the feedback button for any takedown requests</p>
    <p>
      <strong>
        We are not affiliated, associated, authorized, endorsed by, or in any way officially connected with WWE, WWF, WCW, ROH, NJPW, WWE Hall Of Fame, AEW, NWA,
        NXT, or any of their events or ppvs, announcers, actors, extras, employees, wrestlers, superstars - dead and company, or any of its subsidiaries.
      </strong>{" "}
      The name &quot;WWE&quot; as well as related names, marks, emblems and images are registered trademarks.
      The name &quot;AEW&quot; as well as related names, marks, emblems and images are registered trademarks.
    </p>
    <p>
      The use in this website and/or in related promotional print or video material of trademarked names and images is strictly for
      editorial and descriptive purposes, and no commercial claim to their use, or suggestion of sponsorship or endorsement, is made by WWE.
      Those words or terms that the authors and publisher have reason to believe are trademarks are designated as such by the use of initial
      capitalization, where appropriate. However no attempt has been made to identify or designate all words or terms to which trademark or
      other proprietary rights may exist. Nothing contained herein is intended to express a judgment on, or affect the validity of legal
      status of, any word or term as a trademark, service mark, or other proprietary mark.
    </p>
    <Box>Please contact use via the feeedback for any takedown requests</Box>
  </Box>
)

const Legal = () => {
  const [expanded, setExpanded,] = useState(false)
  const handleChange = (panel) => (event, isExpanded) => setExpanded(isExpanded ? panel : false)

  return (
    <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
      <AccordionSummary aria-controls="panel1bh-content" id="panel1bh-header">
        <HeaderBody>Notice of Non-Affiliation and Disclaimer</HeaderBody>
      </AccordionSummary>
      <AccordionDetails>
        <LegalNotice />
      </AccordionDetails>
    </Accordion>
  )
}

export default Legal
